const initialState = {
  // ==================== Old
  barCharts: {
    series: [],
    info: {},
  },
  verticalColumns: {
    series: [],
    info: {},
  },
  dashboardBar: {
    invites: 0,
    answers: 0,
    clients: 0,
  },
  answersByPhone: {
    total: 0,
    byPhone: 0,
    percentil: 0,
  },
  answersByEmail: {
    total: 0,
    byEmail: 0,
    percentil: 0,
  },
  answersByManual: {
    total: 0,
    byEmail: 0,
    percentil: 0,
  },
  npsByDate: null,
  reports: {
    basicColumn: {
      series: [],
      categories: [],
      nps: 0,
      answers: 0,
      promoters: {
        daily: [],
        total: 0,
        percentil: 0,
      },
      neutrals: {
        daily: [],
        total: 0,
        percentil: 0,
      },
      detractors: {
        daily: [],
        total: 0,
        percentil: 0,
      },
    },
    assessments: {},
    categories: {
      generalItems: {
        items: {},
      },
    },
    indicators: [],
    rankings: {
      csat: [],
      emotion: [],
      likeDislike: [],
      likert: [],
      reviews: [],
    },
  },
  // ==================== end Old

  npsEvolution: {},
  selectIndicators: [],
  answersEvolution: {},
  invitesEvolution: {},
  percentageEvolution: {},
  totalActionList: 0,
  ItemsComparativeActions: [],
  csatData: [],
  emotionData: [],
  likeDislikeData: [],
  likertData: [],
  reviewsData: [],
  reportCategories: [],
  reportTags: [],
  reportNpsIndicators: [],
  reportsEmotions: {
    promoters: 0,
    passive: 0,
    detractors: 0,
  },
  wordcloud: {},
  // Refactor Rankings 09/07
  filterRankings: null,
  requestParams: {
    token: null,
    companyId: null,
    actionId: null,
    page: null,
    limit: null,
    startDate: null,
    endDate: null,
    ih1: null,
    ih2: null,
    metric: null,
    filter: null,
  },
};

export default initialState;



// WEBPACK FOOTER //
// ./src/store/modules/charts/initialState.js